/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContentDetail } from '../../models/content-detail';

export interface CreateContent$Params {

/**
 * ID sekcie
 */
  sectionId: number;
      body?: ContentDetail
}

export function createContent(http: HttpClient, rootUrl: string, params: CreateContent$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentDetail>> {
  const rb = new RequestBuilder(rootUrl, createContent.PATH, 'post');
  if (params) {
    rb.query('sectionId', params.sectionId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContentDetail>;
    })
  );
}

createContent.PATH = '/admin/content';
